import { useCallback } from 'react';
import { Link as NavLink } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';
import { v4 as uuidv4 } from 'uuid';

import { Paper, Tooltip } from '@mui/material';
import { Role } from '../../recoil/atoms/user';
import { permissionsSelector } from '../../recoil/selectors/permissionsSelector';
import { timeSaved } from '../../recoil/selectors/timeSaved';
import { TimeSavedBarChart } from '../components/charts/TimeSavedBarChart';
import { TeamDropdown } from '../components/dropdowns/TeamDropdown';
import { TimeSavedMetrics } from '../components/dropdowns/TimeSavedMetrics';
import dataTableScss from '../modules/Manage/pages/queues-table/data-table.module.css';
import { DataTable } from '../modules/Manage/pages/queues-table/DataTable';
import { EnhancedTableToolbar } from '../modules/Manage/pages/queues-table/EnhancedTableToolbar';
import { QueuesSkeleton } from '../modules/Skeleton/QueuesSkeleton';

const sortModel = [
  {
    field: 'total',
    sort: 'desc',
  },
];
function emailFormatter(params) {
  const permissionsLoadable = useRecoilValueLoadable(permissionsSelector);
  const { role } = permissionsLoadable.contents;
  const isUser = role === Role.USER;

  return isUser ? (
    params.value
  ) : (
    <Tooltip title="Edit Agent">
      <NavLink to={`/manage/agents/${params.row.userid}/edit`}>
        {params.value}
      </NavLink>
    </Tooltip>
  );
}
const columns = [
  {
    field: 'email',
    headerName: 'Email',
    headerClassName: dataTableScss.fullWidth,
    cellClassName: dataTableScss.fullWidth,
    renderCell: emailFormatter,
  },
  {
    field: 'total',
    headerName: 'Total',
    headerClassName: dataTableScss.fullWidth,
    cellClassName: dataTableScss.fullWidth,
  },
  {
    field: 'c2c',
    headerName: 'C2C',
    headerClassName: dataTableScss.fullWidth,
    cellClassName: dataTableScss.fullWidth,
  },
  {
    field: 'loggedCall',
    headerName: 'Logged Call',
    headerClassName: dataTableScss.fullWidth,
    cellClassName: dataTableScss.fullWidth,
  },
  {
    field: 'incomingCall',
    headerName: 'Incoming Call',
    headerClassName: dataTableScss.fullWidth,
    cellClassName: dataTableScss.fullWidth,
  },

  {
    field: 'autoSMS',
    headerName: 'Auto SMS',
    headerClassName: dataTableScss.fullWidth,
    cellClassName: dataTableScss.fullWidth,
  },
  {
    field: 'smsTemplate',
    headerName: 'SMS Template',
    headerClassName: dataTableScss.fullWidth,
    cellClassName: dataTableScss.fullWidth,
  },
  {
    field: 'vmDrop',
    headerName: 'VM Drop',
    headerClassName: dataTableScss.fullWidth,
    cellClassName: dataTableScss.fullWidth,
  },
];
export default function TimeSaved(props) {
  const data = useRecoilValueLoadable(timeSaved);

  let editable = [];
  if (data.state === 'hasValue') {
    editable = data?.contents?.stats.map((o) => ({
      ...o,
      id: uuidv4(),
    }));
  }
  const ToolbarComponent = useCallback(
    (props) => <EnhancedTableToolbar {...props} />,
    []
  );
  return (
    <Paper square={true} elevation={0}>
      <TeamDropdown />
      <TimeSavedMetrics />
      <TimeSavedBarChart />
      {data.state === 'loading' && <QueuesSkeleton />}
      <DataTable
        columns={columns}
        rows={editable}
        sortModel={sortModel}
        ToolbarComponent={ToolbarComponent}
        loading={data.state === 'loading'}
      />
    </Paper>
  );
}
